import { render, staticRenderFns } from "./codes.vue?vue&type=template&id=21f17186&scoped=true"
import script from "./codes.vue?vue&type=script&lang=js"
export * from "./codes.vue?vue&type=script&lang=js"
import style0 from "./codes.vue?vue&type=style&index=0&id=21f17186&prod&lang=scss"
import style1 from "./codes.vue?vue&type=style&index=1&id=21f17186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f17186",
  null
  
)

export default component.exports